import styled from '@emotion/styled';
import { BorderColor, FontColor, BgColor } from 'ui/theme/Color';
import sideMenuAdd from 'components/asset/images/sideMenuAdd.svg';
import sideMenuMinus from 'components/asset/images/sideMenuAdd.svg';

export const TreeBox = styled.div`
  height: 100%;
  // min-height: 300px;
  // padding: 10px 0;
  border: 1px solid ${BorderColor.Primary};
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 6px; /* 스크롤바의 너비 */
    height: 6px;
    background: white; /*스크롤바 뒷 배경 색상*/
  }

  &::-webkit-scrollbar-thumb {
    height: 10%; /* 스크롤바의 길이 */
    background: #8d8d8d; /* 스크롤바의 색상 */
    border-radius: 30px;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }
`;

export const Tree = styled.div`
  margin-top: 5px;
  label {
    display: inline-block;
    position: relative;
    padding: 4px 0 6px;
    cursor: pointer;
    color: ${FontColor.Gray400};
    width: 100%;
    height: 30px;
    font-size: 13px;

    &.on {
      background-color: ${BgColor.Secondary50};

      :after {
        content: '';
        display: inline-block;
        width: 3px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${BgColor.Secondary100};
      }
    }

    &.root {
      color: ${FontColor.Default};
    }
    &.root:before {
      background-image: url(${sideMenuMinus});
    }

    &:hover,
    &:focus,
    &.on {
      background-color: ${BgColor.Secondary50};

      :after {
        content: '';
        display: inline-block;
        width: 3px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${BgColor.Secondary100};
      }
    }

    &:before {
      content: '';
      width: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: -6px;
      background: url(${sideMenuMinus}) no-repeat center;
    }

    &.lastTree:before {
      background-image: none;
    }
  }

  li {
    position: relative;
    list-style: none;

    &:before {
      content: '';
      display: inline-block;
      width: 1px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 10px;
    }

    &.lastList {
      :before {
        display: none;
      }
    }

    &.hasCheckbox > label:before {
      margin-right: 28px;
    }

    .MuiCheckbox-root {
      position: absolute;
      left: 26px;
      top: 8px;
      z-index: 2;
      input {
        display: block;
      }
      .Mui-checked {
        color: #3ec2cf;
      }
    }
  }

  ul {
    display: none;
  }

  *:before {
    width: 15px;
    height: 15px;
    display: inline-block;
  }

  input[type='checkbox'] {
    display: none;
    &:checked ~ ul {
      display: block;
    }
    &:checked ~ ul > li {
      label {
        padding-left: 20px;
      }
    }

    &:checked ~ ul > li ul > li {
      label {
        padding-left: 40px;
      }
    }

    &:checked ~ ul > li ul > li ul > li {
      label {
        padding-left: 60px;
      }
    }

    &:checked + label:before {
      background-image: url(${sideMenuAdd});
    }

    &:checked + label.lastTree:before {
      background-image: none;
    }

    &:checked + label.root:before {
      background-image: url(${sideMenuAdd});
    }
  }

  [datatype='N'] {
    color: ${FontColor.Gray200} !important;
  }
`;
